import type { FormInstance } from '@arco-design/web-react';

import { getDeployPluginHeadless } from '../../../core/registry';
import type { PipelineContext } from '../../../core/types';

/** innerForm → fresh displayConfig（pipeline 同源，供 SKU 计价监听使用） */
export function buildMiFreshDisplayConfig(innerForm: FormInstance, ctx: PipelineContext) {
  const plugin = getDeployPluginHeadless('ModelInstance');
  try {
    return plugin.pipeline.prepareSkuSubmit(innerForm, ctx).displayConfig;
  } catch {
    return [];
  }
}
